export default __webpack_public_path__ + "static/media/Facebook.68415b17.svg";